import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import universal from 'react-universal-component';
import { PageLoading } from './PageLoading';
import { PageError } from './PageError';

const load = (props) =>
  Promise.all([import(/* webpackChunkName: '[request]' */ `../../../pages/${props.page}`)]).then(
    (proms) => proms[0],
  );

const UniversalComponent = universal(load, {
  chunkName: (props) => props.page,
  resolve: (props) => require.resolveWeak(`../../../pages/${props.page}`),
  error: PageError,
  loading: PageLoading,
});

const SwitcherComponent = (props) => <UniversalComponent {...props} />;
SwitcherComponent.propTypes = {
  page: PropTypes.string.isRequired,
};

const mapState = ({ page }) => ({
  page,
});

export const Switcher = connect(mapState)(SwitcherComponent);
